import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import styledComponent from '../../utils/styledComponent';

/*     STYLED COMPONENT     */

const StyledDiv = styledComponent('div', {
  '&.filterRow': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  '&.footerWrapper': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
});

/*     CONFIRMATIONMODAL COMPONENT     */

const ConfirmationModal = (props) => {
  const isDeployment =
    props.deploymentInfo.deployment.selectedSoftware &&
    props.deploymentInfo.deployment.selectedVersion;
  return (
    <StyledDiv>
      {!props.isDeployDisabled && (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            style={{
              backgroundColor: '#D3EBC2',
              height: 'fit-content',
              display: 'flex',
              // alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Modal.Title
              id="contained-modal-title-vcenter"
              style={{
                width: '562px',
                height: '35px',
                fontWeight: '550px',
                fontSize: '26px',
                lineHeight: '35px',
              }}
            >
              Are you sure you want to deploy this{' '}
              {isDeployment ? 'software' : 'pilot'}?
            </Modal.Title>
            {isDeployment && props.isPilot && (
              <span>
                Once you deploy this software, the FridgeSoftwareVersion and the
                FridgeSoftwarePilot table will be updated.
              </span>
            )}
            {isDeployment && !props.isPilot && (
              <span>
                Once you deploy this software, the FridgeSoftwareVersion table
                will be updated.
              </span>
            )}
            {!isDeployment && props.isPilot && (
              <span>
                Once you deploy this software, the FridgeSoftwarePilots table
                will be updated.
              </span>
            )}
          </Modal.Header>
          <Modal.Body>
            {isDeployment && (
              <>
                <h4
                  style={{
                    fontWeight: '550',
                  }}
                >
                  Deployment
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>
                    Software: {props.deploymentInfo.deployment.selectedSoftware}
                  </span>
                  <span>
                    Version:{' '}
                    {props.deploymentInfo.deployment.selectedVersion.rawVersion}
                  </span>
                  <span>
                    {props.deploymentInfo.deployment.selectedFridges.size}{' '}
                    fridges to deploy to:
                  </span>
                  <textarea
                    disabled
                    style={{
                      resize: 'none',
                      height: '145px',
                      marginBottom: '0px',
                      border: 'none',
                      background: '#EEEEEE',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                    }}
                    value={Array.from(
                      props.deploymentInfo.deployment.selectedFridges,
                    ).join('\n')}
                  />
                </div>
              </>
            )}
            {props.isPilot && (
              <>
                <h4
                  style={{
                    fontWeight: '550',
                  }}
                >
                  Pilot
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>
                    Pilot ID:
                    {props.deploymentInfo.pilot.id}
                  </span>
                  <span>
                    Display Name: {props.deploymentInfo.pilot.displayName}
                  </span>
                  <span>
                    Stage:
                    {props.deploymentInfo.pilot.stage}
                  </span>
                  <span>
                    Start Date: {props.deploymentInfo.pilot.startDate}
                  </span>
                  <span>
                    End Date:
                    {props.deploymentInfo.pilot.endDate}
                  </span>
                  <span>Description:</span>
                  <textarea
                    disabled
                    style={{
                      resize: 'none',
                      marginBottom: '0px',
                      border: 'none',
                      background: '#EEEEEE',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                    }}
                    value={props.deploymentInfo.pilot.description}
                  />
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div
              className="footerWrapper"
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <div className="buttonWrapper">
                <Button
                  onClick={() => {
                    props.onHide();
                  }}
                  style={{ color: '#368007', border: 'none', outline: 'none' }}
                >
                  NO, CANCEL
                </Button>
                <Button
                  onClick={() => {
                    props.onHide();
                    props.deploySoftware();
                  }}
                  style={{
                    color: '#FFFFFF',
                    border: 'none',
                    backgroundColor: '#368007',
                    outline: 'none',
                  }}
                >
                  YES, CONFIRM
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </StyledDiv>
  );
};

export default ConfirmationModal;
